/**
 * entries/proveedor.jsx -- Entry point de proveedor.html. Sin
 * App.jsx del portal interno -- este arbol es 100%
 * independiente (ver nota de aislamiento en proveedor.html).
 */
import { StrictMode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import ProveedorApp from '../routes/proveedor/ProveedorApp.jsx';

// Entrada antigua/local compatible; el subdominio usa rutas desde la raíz.
const basename = window.location.pathname.startsWith('/proveedor.html') ? '/proveedor.html' : '/';

createRoot(document.getElementById('root')).render(
  <StrictMode><BrowserRouter basename={basename}><ProveedorApp /></BrowserRouter></StrictMode>,
);
